import {FloodRiskProfile} from '@/components/flood/floodProfile';

// Decimal places the server keeps of a coordinate (about 0.1 m).
const COORDINATE_DECIMALS = 6;

/**
 * A coordinate as the endpoint takes it: Nette refuses a float parameter it cannot read back to the
 * same text, so a position on the map (16 or 17 digits) is rounded to what the server keeps anyway,
 * and the trailing zeros of the rounding go too ("50.086500" is refused as well).
 */
function coordinateParameter(value: number): string {
    return String(Number(value.toFixed(COORDINATE_DECIMALS)));
}

/**
 * The flood risk profile of a place: what the flood layers say about it. Served on every domain,
 * so the pages and forms of any module ask the same way. Rejects where the request fails.
 */
export function loadFloodProfile(latitude: number, longitude: number): Promise<FloodRiskProfile> {
    const queryParameters = new URLSearchParams({
        latitude: coordinateParameter(latitude),
        longitude: coordinateParameter(longitude),
    });

    return fetch(`/api/flood-profile?${queryParameters.toString()}`)
        .then(response => {
            if (!response.ok) {
                throw new Error(`The flood profile could not be loaded (${response.status}).`);
            }
            return response.json() as Promise<FloodRiskProfile>;
        });
}
